

import {baseApi} from "@/api/base";
import { artworkSimpleVo,artistSimpleVo,artworkInfoVo,artistInfoVo } from "@/vo/archivesVo";
import {simpleVo as bookSimpleVo } from "@/vo/bookVo";
import { simpleVo as exhibitionSimpleVo } from "@/vo/exhbitionVo";

export class getArtworkList extends baseApi{
	router="/archives/artwork/list";
	method="get";
  conversion(response){   //转换器
    let list = [];
    for(let i in response.records){
      let vo = new artworkSimpleVo();
      vo.convert(response.records[i]);
      list.push(vo);
    }
    return {
      list:list,
      total:response.total
    };
  }
}

export class getArtworkInfo extends baseApi{
	router="/archives/artwork/info";
	method="get";
  conversion(response){   //转换器
    let vo = new artworkInfoVo();
    vo.convert(response);
    return vo;
  }
}

export class getArtistList extends baseApi{
	router="/archives/artist/list";
	method="get";
  conversion(response){   //转换器
    let list = [];
    for(let i in response.records){
      let vo = new artistSimpleVo();
      vo.convert(response.records[i]);
      list.push(vo);
    }
    return {
      list:list,
      total:response.total
    };
  }
}

export class getArtistInfo extends baseApi{
	router="/archives/artist/info";
	method="get";
  conversion(response){   //转换器
    let vo = new artistInfoVo();
    vo.convert(response);
    return vo;
  }
}


export class getArtistArtworks extends baseApi{
	router="/archives/artist/artworks";
	method="get";
  conversion(response){   //转换器
    let list = [];
    for(let i in response){
      let vo = new artworkSimpleVo();
      vo.convert(response[i]);
      list.push(vo);
    }
    return list;
  }
}


export class getArtistBooks extends baseApi{
	router="/archives/artist/books";
	method="get";
  conversion(response){   //转换器
    let list = [];
    for(let i in response){
      let vo = new bookSimpleVo();
      vo.convert(response[i]);
      list.push(vo);
    }
    return list;
  }
}

export class getArtistExhibition extends baseApi{
	router="/archives/artist/exhibition";
	method="get";
  conversion(response){   //转换器
    let list = [];
    for(let i in response){
      let vo = new exhibitionSimpleVo();
      vo.convert(response[i]);
      list.push(vo);
    }
    return list;
  }
}






// WEBPACK FOOTER //
// ./src/api/archives.js